/* eslint-disable no-unreachable */
import React, { useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Box, Button, TextField, Typography } from '@material-ui/core';
import _ from 'lodash';
import LayoutLogin from '../../component/partials/LayoutLogin';
import { REGEX } from '../../utils/constants';
import Api from '../../config/api';
import MuiAlert from '@material-ui/lab/Alert';
import AlertMessage from '@material-ui/lab/Alert';

import Loader from '../../component/Loader';

function Alert(props) {
	return <MuiAlert elevation={6} variant='filled' {...props} />;
}

const SuccessBox = ({ email }) => (
	<Box className='auth-box-message' style={{ width: 350 }}>
		<Box className='forgot_success_box'>
			<h6>REGISTER</h6>
			<p>We have sent you an email to</p>
			<p> <span style={{ fontWeight: 'bold' }}>{email}</span> </p>
			<p>with the steps to complete your account</p>
			<br />
			<p>
				<em>
					<b>Note:</b> if you cannot find our email, please check your spam or junk folders
				</em>
			</p>
		</Box>
		<Box className='button__container'>
			<Link to='/'>
				<Button variant='contained'>Back to login</Button>
			</Link>
		</Box>
	</Box>
);

const Register = (props) => {
	const [emailError, setEmailError] = useState(false);
	const [firstNameError, setFirstNameError] = useState(false);
	const [firstNameErrorMessage, setFirstNameErrorMessage] = useState('');
	const [lastNameError, setLastNameError] = useState(false);
	const [lastNameErrorMessage, setLastNameErrorMessage] = useState('');
	const [disabledButton, setDisabledButton] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [successMessage, setSuccessMessage] = useState('');
	const [nameButton, setNameButton] = useState('VALIDATE');
	const [loading, setLoading] = useState(false);
	const [isComplete, setIsComplete] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [secondParentFirstNameError, setSecondParentFirstNameError] = useState(false);
	const [secondParentFirstNameErrorMessage, setSecondParentFirstNameErrorMessage] = useState('');
	const [secondParentLastNameError, setSecondParentLastNameError] = useState(false);
	const [secondParentLastNameErrorMessage, setSecondParentLastNameErrorMessage] = useState('');
	const [form, setForm] = useState({
		firstname: '',
		lastname: '',
		email: '',
		secondParentFirstname: '',
		secondParentLastname: '',
	});

	const register = (e) => {
		e.preventDefault();

		setDisabledButton(true);
		setNameButton('LOADING...');

		if (form.firstname.length > 120) {
			setFirstNameError(true);
			setFirstNameErrorMessage('First name must have a maximum of 120 characters');
			setNameButton('VALIDATE');
			return;
		}

		if (form.lastname.length > 120) {
			setLastNameError(true);
			setLastNameErrorMessage('Last name must have a maximum of 120 characters');
			setNameButton('VALIDATE');
			return;
		}

		if (form.secondParentFirstname.length > 120) {
			setSecondParentFirstNameError(true);
			setSecondParentFirstNameErrorMessage('Additional parent first name must have a maximum of 120 characters');
			setNameButton('VALIDATE');
			return;
		}

		if (form.secondParentLastname.length > 120) {
			setSecondParentLastNameError(true);
			setSecondParentLastNameErrorMessage('Additional parent last name must have a maximum of 120 characters');
			setNameButton('VALIDATE');
			return;
		}

		if (!REGEX.emailRegEx.test(form.email.toLowerCase())) {
			setEmailError(true);
			setErrorMessage('Email is incorrect');
			setNameButton('VALIDATE');
		}

		if (_.isEmpty(form.email)) {
			setEmailError(true);
			setErrorMessage('Email is required');
			setNameButton('VALIDATE');
		}

		if (_.isEmpty(form.firstname)) {
			setFirstNameError(true);
			setFirstNameErrorMessage('First Name is required');
			setNameButton('VALIDATE');
		}

		if (_.isEmpty(form.lastname)) {
			setLastNameError(true);
			setLastNameErrorMessage('Last Name is required');
			setNameButton('VALIDATE');
		}

		if (_.isEmpty(form.firstname) || _.isEmpty(form.lastname) || _.isEmpty(form.email) || !REGEX.emailRegEx.test(form.email.toLowerCase())) {
			return setNameButton('VALIDATE');
		}

		setLoading(true);

		const body = {
			firstname: form.firstname,
			lastname: form.lastname,
			email: form.email,
			secondParentFirstName: form.secondParentFirstname.trim() || undefined,
			secondParentLastName: form.secondParentLastname.trim() || undefined,
		};
		Api.CreateAccount(body)
			.then((res) => {
				setLoading(false);
				setDisabledButton(false);
				setNameButton('VALIDATE');
				if (res.status !== 201) {
					setAlertMessage(res.message);
					setSuccessMessage(res.message);
					return;
				}
				setIsComplete(true);
				setSuccessMessage(res.message);
				// setForm({
				//     firstname: '',
				//     lastname: '',
				//     email: '',
				// })
			})
			.catch((err) => {
				console.log('Error: ', err);
				setDisabledButton(false);
				setNameButton('VALIDATE');
			});
	};

	const onChangeForm = (e) => {
		const { name, value } = e.target || e;
		setEmailError(false);
		setFirstNameError(false);
		setLastNameError(false);
		setSecondParentFirstNameError(false);
		setSecondParentLastNameError(false);
		setErrorMessage('');
		setSuccessMessage('');
		setDisabledButton(false);
		setAlertMessage('');
		setForm({ ...form, [name]: value });
	};

	return (
		<LayoutLogin title='Register'>
			<Grid item xs={12}>
				<Box className='register_container'>
					{!isComplete ? (
						<Box className='register_container_box'>
							<Typography className='register_container_box_title'>Enter Parent User Information</Typography>
							<span className='register_span'></span>
							<form onSubmit={register} className='register_form' noValidate autoComplete='off' style={{ paddingBottom: 10 }}>
								{/* Set primary Parent/Guardian */}
								<Typography variant='body2' style={{ marginBottom: 8, fontWeight: 500 }}>
									Set primary Parent/Guardian.
								</Typography>
								<Grid container spacing={2}>
									<Grid item xs={12} sm={6}>
										<TextField
											fullWidth
											label='Parent First Name *'
											name='firstname'
											value={form.firstname}
											variant='outlined'
											size='small'
											onChange={onChangeForm}
											error={firstNameError}
											helperText={firstNameError ? firstNameErrorMessage : null}
										/>
									</Grid>
									<Grid item xs={12} sm={6}>
										<TextField
											fullWidth
											label='Parent Last Name *'
											name='lastname'
											value={form.lastname}
											variant='outlined'
											size='small'
											onChange={onChangeForm}
											error={lastNameError}
											helperText={lastNameError ? lastNameErrorMessage : null}
										/>
									</Grid>
								</Grid>

								{/* Set additional Parent/Guardian (optional) */}
								<Typography variant='body2' style={{ marginTop: 20, marginBottom: 8, fontWeight: 500 }}>
									Set additional Parent/Guardian (optional).
								</Typography>
								<Grid container spacing={2}>
									<Grid item xs={12} sm={6}>
										<TextField
											fullWidth
											label='Additional Parent First Name'
											name='secondParentFirstname'
											value={form.secondParentFirstname}
											variant='outlined'
											size='small'
											onChange={onChangeForm}
											error={secondParentFirstNameError}
											helperText={secondParentFirstNameError ? secondParentFirstNameErrorMessage : null}
										/>
									</Grid>
									<Grid item xs={12} sm={6}>
										<TextField
											fullWidth
											label='Additional Parent Last Name'
											name='secondParentLastname'
											value={form.secondParentLastname}
											variant='outlined'
											size='small'
											onChange={onChangeForm}
											error={secondParentLastNameError}
											helperText={secondParentLastNameError ? secondParentLastNameErrorMessage : null}
										/>
									</Grid>
								</Grid>

								{/* Set primary email Account Address */}
								<Typography variant='body2' style={{ marginTop: 20, marginBottom: 8, fontWeight: 500 }}>
									Set primary email Account Address.
								</Typography>
								<TextField
									fullWidth
									label='Primary Email Address *'
									name='email'
									value={form.email}
									variant='outlined'
									size='small'
									onChange={onChangeForm}
									error={emailError}
									helperText={emailError ? errorMessage : null}
									style={{ marginBottom: 8 }}
								/>
								{/* {!!successMessage && <span style={{ color: '#9BB43B' }}>{successMessage}</span>} */}
								{!!alertMessage && (
									<Box style={{ marginTop: 16 }}>
										<Alert onClose={() => setAlertMessage('')} severity='info'>
											{alertMessage}
										</Alert>
									</Box>
								)}
								<Box className='register_button' style={{ marginTop: 20 }}>
									{!loading ? (
										// ? <Button variant="contained" disabled={disabledButton} onClick={register}>{nameButton}</Button>
										<Fragment>
											<Button type='submit' variant='contained' disabled={disabledButton}>
												{nameButton}
											</Button>
											<span className='login_span' style={{ color: 'red' }}>
												<Link to='/login'>Back to login</Link>
											</span>
										</Fragment>
									) : (
										<div style={{ marginTop: 15 }}>
											<Loader loading={true} />
										</div>
									)}
								</Box>
							</form>
						</Box>
					) : (
						<SuccessBox email={form.email} />
					)}
				</Box>
			</Grid>
		</LayoutLogin>
	);
};

export default Register;
